import { app } from '../../../app';
import { Controller } from './notes.controller';

app.component('userPublicNotes', {
    bindings: {notes: '<'},
    controller: Controller,
    templateUrl: require('./notes.html'),
});


// WEBPACK FOOTER //
// ./src/portal/states/user/notes/notes.component.js